import { useState, useEffect } from "react";
import { getClients } from "../services/clients";

let cachedClients = null; // global in-memory cache

export const useClients = ({ reload = false, params = {} } = {}) => {
  const [clients, setClients] = useState(cachedClients || []);
  const [loading, setLoading] = useState(false);

  const fetchClients = async () => {
    setLoading(true);
    try {
      const [err, data] = await getClients(params);
      if (!err) {
        cachedClients = data || [];
        setClients(cachedClients);
      }
    } catch (e) {
      console.error("Error fetching clients:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!cachedClients || reload) {
      fetchClients();
    } else {
      setClients(cachedClients);
    }
  }, [reload, JSON.stringify(params)]); // refetch if reload or params change

  return { clients, loading, refresh: fetchClients };
};
